import { useState } from 'react'
import Input from '.'
import Text from 'components/shared/Text'
import { FormattedMessage } from 'react-intl'

interface PasswordProps {
    id: string
    label?: string
    placeholder?: string
    isDisabled?: boolean
    isRequired?: boolean
    onChange?: (value: string) => void
    onBlur?: (value: string) => void
    isError?: boolean
    errorMessage?: string
    infoMessage?: string
    testId?: string
}

const Password = ({
    placeholder,
    id,
    label,
    isDisabled,
    isRequired = false,
    onChange,
    onBlur,
    isError,
    errorMessage,
    infoMessage,
    testId,
}: PasswordProps) => {
    const [isVisible, setIsVisible] = useState(false)

    return (
        <Input
            type={isVisible ? 'text' : 'password'}
            placeholder={placeholder}
            id={id}
            label={label}
            isDisabled={isDisabled}
            isRequired={isRequired}
            onValueChange={onChange}
            onBlurChange={onBlur}
            isError={isError}
            errorMessage={errorMessage}
            infoMessage={infoMessage}
            isLargePaddingRight
            testId={testId}
        >
            <Text
                variant="bodySmall"
                color="grayscale_700"
                onClick={() => setIsVisible(!isVisible)}
            >
                {isVisible ? (
                    <FormattedMessage
                        id="global.btn.hide"
                        defaultMessage="Ukryj"
                    />
                ) : (
                    <FormattedMessage
                        id="global.btn.show"
                        defaultMessage="Pokaż"
                    />
                )}
            </Text>
        </Input>
    )
}

export default Password
